import type { Block } from '@/blocks/domain/types';
import { blockKindDisplayLabel } from '@/blocks/domain/helpers/blockKindDisplayLabel';

/**
 * The name a block is shown under. The API never answers a blank name any more (it stores the kind's
 * display name), but a row, a cached response or an older host can still carry `null`/`""`: the card
 * title, the "Open …" / "Block actions for …" names and the editor header must never read "null" or be
 * empty, so the kind label (`BLOCK_KIND_LABELS`, the same text the server defaults to) stands in.
 */
export function resolveBlockName(name: string | null | undefined, block: Pick<Block, 'kind' | 'rawKind' | 'isSupportedKind'>): string {
  return name != null && name.trim() !== '' ? name : blockKindDisplayLabel(block);
}
